import { UPLOAD_SOURCES } from '@cld/upload-widget';
import { asAbsolute } from 'root/routes/utils';

const { UNSPLASH } = UPLOAD_SOURCES;

export const getInternalPath = (page) => {
  return page ? asAbsolute(UNSPLASH, page) : asAbsolute(UNSPLASH);
};

export const getSelectedItemByValue = (value, options) => options.find((item) => item.value === value);
